import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDAC3Oc39grEotMZZGtjueiZz-GgX__Y00",
  authDomain: "dunningkruger-8eebb.firebaseapp.com",
  projectId: "dunningkruger-8eebb",
  storageBucket: "dunningkruger-8eebb.appspot.com",
  messagingSenderId: "728267431214",
  appId: "1:728267431214:web:0c1ec4b005ff01b17c6ebf",
  measurementId: "G-ETV3THMP1V"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
